import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight, PlayCircle } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";

export default function Guides() {
  const navigate = useNavigate();
  const [guides, setGuides] = useState([]);

  useEffect(() => { api.get("/guides").then((r) => setGuides(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 py-8 sm:py-12">
      <div className="mb-8">
        <span className="overline text-brand-terracotta">In The Home</span>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight mt-2">How-To Guides</h1>
        <p className="text-brand-forest/60 mt-2">Step-by-step help for the appliances and gadgets around the house.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {guides.map((g, i) => (
          <motion.button
            key={g.id}
            data-testid={`guide-card-${g.id}`}
            onClick={() => navigate(`/guides/${g.id}`)}
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: i * 0.05 }}
            className="text-left bg-white rounded-3xl overflow-hidden border border-black/5 shadow-sm hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow] active:scale-[0.98]"
          >
            <div className="relative h-48 overflow-hidden bg-brand-sand">
              {g.cover_image && <img src={mediaUrl(g.cover_image)} alt={g.title} className="h-full w-full object-cover" />}
              <div className="absolute inset-0 bg-gradient-to-t from-brand-forest/50 to-transparent" />
              <PlayCircle className="absolute bottom-4 right-4 text-white" size={30} />
              {g.appliance && (
                <span className="absolute top-4 left-4 overline text-white bg-black/30 rounded-full px-3 py-1">{g.appliance}</span>
              )}
            </div>
            <div className="p-6 flex items-center justify-between">
              <div>
                <h3 className="font-display text-xl tracking-tight">{g.title}</h3>
                <p className="text-sm text-brand-forest/60 mt-1">{(g.steps || []).length} steps</p>
              </div>
              <ChevronRight className="text-brand-terracotta" />
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
